import React, { useEffect, useState } from "react";
import Tree from "react-d3-tree";
import "../styles/FTree2.css";
import "../styles/FamilyTree.css";
import { CiCirclePlus } from "react-icons/ci";
import { BsPlusCircle } from "react-icons/bs";
import { useNavigate } from "react-router";

const familyTree = {
  name: "Thomas ",
  attributes: { spouse: "Mary   " },
  children: [
    {
      name: "Brad ",
      attributes: { spouse: "Jane " },
      children: [],
    },
    {
      name: "Brad ",
      attributes: { spouse: "Jane " },
      children: [],
    },
    {
      name: "Mike ",
      attributes: { spouse: "Sara " },
      children: [
        {
          name: "John ",
          attributes: { spouse: null },
          children: [],
        },
      ],
    },
  ],
};
const image =
"https://img.freepik.com/free-vector/smiling-young-man-illustration_1308-174401.jpg?semt=ais_hybrid";

const renderCustomNode = ({ nodeDatum, parentNode }) => {

  const isFirstNode = !parentNode; 
  const isSpouseOfFirstNode = parentNode?.attributes?.spouse === nodeDatum.name;

  return(
  <g className="brakeandpay">
  {/* Spouse Node */}
    {/* {(isFirstNode || isSpouseOfFirstNode) && (
      )} */}
  {nodeDatum.attributes?.spouse && (
    
        <>
        <div className="ribbon">
          <img
            src={require("../assets/images/Autolayout Ribbon.png")}
            alt="Ribbon"
          />
        </div>
        <div className="ribbon">
        <img src={require("../assets/images/Autolayout Ribbon.png")} alt="" />
      </div>
  <rect
      x={-142}
      y={-120}
      width={280}
      height={225}
      fill="#E9E5D5" // Background color
      rx={32}
      stroke="none" // Rounded corners
    />
    <foreignObject width="132" height="225" x={-142} y={-120}>
      <div className="custom-node">
        <img src={image} alt={nodeDatum.name} className="node-image" />
        <div className="node-details">
          <h4 className="node-title">{nodeDatum.name}</h4>
          <p className="node-description">Position</p>
          <p className="node-phone">📞 +234800000000</p>
          <p className="node-phone">🎂 9 May 1990</p>
        </div>
      </div>
    </foreignObject>
    <BsPlusCircle
      size={24}
      style={{
        cursor: "pointer",
        fill: "#c5b78c",
        transform: "scale(1)",
        transition: "transform 0.2s ease",
      }}
      x={-7}
      y={-20}
    />
      <foreignObject width="132" height="225" x={19} y={-120}>
        <div className="custom-node spouse-node">
          <img src={image} alt={nodeDatum.attributes.spouse} className="node-image" />
          <div className="node-details">
            <h4 className="node-title">{nodeDatum.attributes.spouse}</h4>
            <p className="node-description">Spouse</p>
          </div>
        </div>
      </foreignObject>
        </>
    )}
    {!nodeDatum.attributes?.spouse && (
      <>
        <foreignObject width="132" height="220" x={-65} y={-120}>
          <div className="custom-node">
            <img src={image} alt={nodeDatum.name} className="node-image" />
            <div className="node-details">
              <h4 className="node-title">{nodeDatum.name}</h4>
              <p className="node-description">Position</p>
              <p className="node-phone">📞 +234800000000</p>
              <p className="node-phone">🎂 9 May 1990</p>
            </div>
          </div>
        </foreignObject>
      </>
    )
    }
  </g>
  )
};

export default function FamilyTree() {
  const [scale, setScale] = useState(1); // Initial scale
  const [treeHeight, setTreeHeight] = useState(0);
  const nodeHeight = 300; 
  const navigate = useNavigate()

  // Dynamically calculate scale based on window size
  const calculateScale = () => {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    // Adjust scale based on width and height
    const newScale = Math.min(screenWidth / 600, screenHeight / 700); // Adjust the divisors as needed
    setScale(newScale < 0.5 ? 0.5 : newScale); // Minimum scale of 0.5 to avoid too much shrinking
  };


  // Calculate the depth of the tree (number of levels)
  const calculateTreeDepth = (node, depth = 0) => {
    if (!node.children || node.children.length === 0) return depth;
    return Math.max(...node.children.map((child) => calculateTreeDepth(child, depth + 1)));
  };
  const handleTreeUpdate = () => {
    const depth = calculateTreeDepth(familyTree);
    setTreeHeight((depth + 1) * nodeHeight); // Calculate based on depth
  };
  
  
  useEffect(() => {
    handleTreeUpdate();
    calculateScale(); // Calculate on initial load
    window.addEventListener("resize", calculateScale); // Recalculate on window resize
    return () => window.removeEventListener("resize", calculateScale); // Cleanup listener
  }, []);
  return (
    <>
    <div className="ftreeButton">
        <button onClick={() => navigate("connect")}>Connect to Family Tree</button>
      </div>
      {/* <div id="treeWrapper" style={{ width: "100vw", height: "80vh" }}> */}
      {/* <div className="ribbon">
        <img src={require("../assets/images/Autolayout Ribbon.png")} alt="" />
      </div> */}
        <Tree
          data={familyTree}
          renderCustomNodeElement={renderCustomNode}
          orientation="vertical" // Makes it more family tree-like
          pathFunc="step" // Uses elbow connectors for better appearance
          nodeSize={{ x: 340, y: 300 }} // Adjust spacing between nodes
          separation={{ siblings: 1, nonSiblings: 1.5 }}
          translate={{ x: window.innerWidth / 2, y: 130 }} 
          // draggable={false}
          zoomable={false}
          enableLegacyTransitions
          draggable={true}
          transitionDuration={1000}
          // depthFactor={300}
          initialDepth={200}
          svgClassName="treeContainer"
          zoom={scale} // Dynamically set scale
        />
        <style>{`
        .treeContainer {
          height: ${treeHeight}px; /* Set dynamic height */
          width: 100%;
        }
      `}</style>
      {/* </div> */}
        <div className="ftreeButton2">
        <button onClick={() => navigate("connect")}>Connect to Family Tree</button>
      </div>

    </>
  );
}
